import { render } from "./exp.vue?vue&type=template&id=6d1d9a87&scoped=true"
import script from "./exp.vue?vue&type=script&lang=js"
export * from "./exp.vue?vue&type=script&lang=js"

import "./exp.vue?vue&type=style&index=0&id=6d1d9a87&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1d9a87"]])

export default __exports__